import { render, staticRenderFns } from "./AddGroupUserModal.vue?vue&type=template&id=23a61966"
import script from "./AddGroupUserModal.vue?vue&type=script&lang=ts"
export * from "./AddGroupUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports